import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Modal, message, Input, Spin } from 'antd';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config";

import './ResetPwd.css';

class ResetPwd extends Component {

  state = {
    confirmDirty: false,
    visible: this.props.visible,
    errMsg: '',
    loading: false,
  };

  componentWillReceiveProps(thisProps) {
    if (thisProps.visible === true) {
      this.setState({
        visible: true
      })
    }
  }


  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        const userPool = new CognitoUserPool(POOL_DATA);
        const cognitoUser = userPool.getCurrentUser();

        if (cognitoUser !== null) {
          cognitoUser.getSession((err, session) => {
            if (err) {
              message.error('The session has expired, please login again');
              this.props.history.push('/login');
              return;
            }
            if (session.isValid() === true) {
              this.setState({
                loading: true,
              });
              cognitoUser.changePassword(values.oldPassword, values.newPassword, (err, result) => {
                if (err) {
                  if (String(err).indexOf('Incorrect') !== -1) {
                    this.setState({
                      errMsg: 'Wrong password, Please check'
                    })
                  } else {
                    message.error(String(err).split(': ')[1]);
                  }
                  return;
                }
                message.success('You have successfully changed the password');
                this.setState({
                  visible: false,
                  errMsg: '',
                  loading: false,
                });
                this.props.setVisible();
              });
            } else {
              message.error('The session has expired, please login again');
              this.props.history.push('/login');
            }
          });
        } else {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
        }
      }
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      errMsg: '',
    });
    this.props.setVisible();
  };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Password is not match.');
    } else {
      callback();
    }
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        visible={this.state.visible}
        className="ResetPwd"
        onCancel={this.handleCancel}
        confirmLoading={true}
        key={this.props.key}
      >
        <h2>Change your password</h2>
        <p>Set your new password if you still remember your old password</p>
        <Spin spinning={this.state.loading}>
        <Form className="confirm-form" onSubmit={this.handleSubmit}>
          <Form.Item>
            <span>Old Password</span>
            {getFieldDecorator('oldPassword', {
              rules: [
                { required: true, message: 'Please input your old password' },
                { min: 8, message: 'Password is too short ( need more than 8 characters ).' },
              ],
            })(
              <Input type="password" placeholder="Old Password"/>
            )}
            <span className="errMsg">{this.state.errMsg}</span>
          </Form.Item>
          <Form.Item hasFeedback>
            <span>New Password</span>
            {getFieldDecorator('newPassword', {
              rules: [
                { required: true, message: 'Please input your new password' },
                { min: 8, message: 'Password is too short ( need more than 8 characters ).' },
                { validator: this.checkConfirm }
              ],
            })(
              <Input type="password" placeholder="New Password"/>
            )}
          </Form.Item>
          <Form.Item hasFeedback>
            <span>Confirm password</span>
            {getFieldDecorator('confirm', {
              rules: [
                { required: true, message: 'Please repeat your Password' },
                { validator: this.checkPassword }],
            })(
              <Input type="password" placeholder="Enter again" onBlur={this.handleConfirmBlur}/>
            )}
          </Form.Item>
          <Form.Item>
            <button>Confirm</button>
          </Form.Item>
        </Form>
        </Spin>
      </Modal>
    );
  }
}

export default withRouter(Form.create()(ResetPwd));



// WEBPACK FOOTER //
// ./src/Containers/Profile/components/ResetPwd.js